import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import { Twitter, Facebook, WhatsApp } from '@mui/icons-material';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import EditIcon from '@mui/icons-material/Edit';
import useRTL from 'src/hooks/useRTL';

const useStyles = makeStyles((theme) => ({
  root: {
    transform: 'translateZ(0px)',
    flexGrow: 1,
  },
  speedDial: props => ({
    position: 'absolute',
    bottom: props.productType === 'categories' ? '25px' : '9px',
    ...(props.isRTL && {left: theme.spacing(2)} ),
    ...(!props.isRTL && {right: theme.spacing(2)} ),
  }),

  fabButton: {
    width:'35px',
    height:'35px',
    backgroundColor:'#15476D',
    color:'#fff',
    '&:hover':{
      backgroundColor:'#15476D'
    }
  },

  speedActionButton:{
    width:'35px',
    height:'35px',
    color: "#15476D",
    backgroundColor:"#fff",
    '&:hover':{
      backgroundColor:'#17C799',
      color:'#fff'
    },
    '& svg':{
      fontSize:'1rem'
    }
  }
}));

export default function ShareFloatButtons({ facebookLink, twitterLink, whatsappLink, productType}) {
  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);
  const [t, isRTL, fontFamily] = useRTL();
  const classes = useStyles({productType,isRTL});


  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const shareEvent = link => {
    window.open(link,'_blank');
    setOpen(false);
  }

  const actions = [
    { icon: <Twitter />, name: 'Twitter', clickEvent: () => shareEvent(twitterLink) },
    { icon: <Facebook />, name: 'Facebook', clickEvent: () => shareEvent(facebookLink) },
    { icon: <WhatsApp />, name: 'Whatsapp', clickEvent: () => shareEvent(whatsappLink) },
  ];

  return (
    <div className={classes.root}>
      <SpeedDial
        ariaLabel="SpeedDial openIcon example"
        className={classes.speedDial}
        classes={{fab:classes.fabButton}}
        hidden={hidden}
        icon={<ShareIcon style={{fontSize:'1rem'}} />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.clickEvent}
            classes={{fab:classes.speedActionButton}}
          />
        ))}
      </SpeedDial>
    </div>
  );
}
